import React, { Component, PropTypes } from 'react';

class NotFound extends Component {
  componentWillMount() {
    const { router } = this.context;
    router.push('/');
  }

  /**
   * This will never be hit. The default action for this component is
   * to redirect to route. If requried, this component could display
   * a 404 and give the user options to choose from.
   */
  render() {
    return (
      <div>
        <p>Not found, redirecting..</p>
      </div>
    );
  }
}

NotFound.contextTypes = {
  router: PropTypes.object
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/features/not-found/NotFound.js